import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import Table from "components/Admin/ArchivedBatches/ArchivedBatches";

import { useDispatch, useSelector } from "react-redux";
import { getCollectedBatches } from "store/actions/archivedBatches";

const CollectedBatches = () => {
  const dispatch = useDispatch();
  const { collectedBatches } = useSelector((state) => state.archivedBatches);
  const [page, setPage] = useState(
    collectedBatches ? collectedBatches.pag.page : 1
  );
  const [amount, setAmount] = useState(
    collectedBatches ? collectedBatches.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    collectedBatches ? collectedBatches.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    collectedBatches ? collectedBatches.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(
    collectedBatches ? collectedBatches.pag.search_by : "branch_name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getCollectedBatches(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, dispatch]);

  const showBatchHandler = (id) => {
    history.push("/admin/archived-batches/item/" + id);
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Collected Archived Batches</h4>
        </CardHeader>
        <CardBody>
          {collectedBatches && (
            <div>
              <Table
                rows={collectedBatches.data}
                totalRows={collectedBatches.pag.total}
                rowsPerPage={amount}
                setRowsPerPage={setAmount}
                order={orderType}
                setOrder={setOrderType}
                orderBy={orderField}
                setOrderBy={setOrderField}
                page={page - 1}
                setPage={setPage}
                searchHandler={setSearchValue}
                searchValue={searchValue}
                selectedSearchBy={searchBy}
                handleSearchByChange={setSearchBy}
                showBatch={showBatchHandler}
                isCollected={true}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default CollectedBatches;
